export const environment = {
	baseUrl: 'https://eris-stg.gainkodex.com',
	production: false,
	pathBackend: 'https://eris-stg.gainkodex.com/api/v1',
	get API_URL(): string {
		return this.pathBackend;
	},
};
